import { z } from 'zod';

/**
 * Login form password validation.
 *
 * A LOGIN form must not enforce password-composition policy (length,
 * complexity) — that belongs to registration/change-password flows
 * (`password.validation.ts`, `user.validation.ts`, which keep their
 * min-8 rules). The server is the authenticator: the client only
 * requires the field to be non-empty so it never pre-rejects a
 * credential the backend would accept (e.g. short QA/legacy passwords).
 *
 * Parity: the AIM login form (apps/aegix-aim-react/src/modules/auth/
 * login/index.tsx) does not gate submission on password shape either.
 */
export const loginPasswordSchema = z
  .string()
  .min(1, 'Password is required');
